export default function HotelResultService() {
    'ngInject';

    Object.assign(this, {
        prepareFiltersModel,
        getFilterProperties,
    });

    const PROPERTIES_WITHOUT_CHANGES = ['hotelName', 'MaximumRadius', 'MaximumTotalPriceFilter', 'MinimumTotalPriceFilter'];
    const PROPERTIES_SHOULD_BE_CONVERTED_TO_ARRAY_OF_NUMBERS = ['StarRatingFilter', 'MainAmenityFilter', 'PaymentTypeFilter', 'RefundableFilter'];
    const PROPERTIES_SHOULD_BE_CONVERTED_TO_ARRAY_OF_STRINGS = ['AmenitiesFilter', 'RateFilter'];

    function prepareFiltersModel(filters, $stateParams) {
        for (const prop in $stateParams) {
            if ($stateParams[prop]) {
                if (PROPERTIES_SHOULD_BE_CONVERTED_TO_ARRAY_OF_NUMBERS.includes(prop)) {
                   $stateParams[prop] = angular.isArray($stateParams[prop])
                       ? $stateParams[prop].map(Number)
                       : $stateParams[prop].split().map(Number);
                }
                if (PROPERTIES_SHOULD_BE_CONVERTED_TO_ARRAY_OF_STRINGS.includes(prop) && !angular.isArray($stateParams[prop])) {
                    $stateParams[prop] = $stateParams[prop].split();
                }
            }
        }

        Object.assign(filters, $stateParams);
    }

    function getFilterProperties() {
        return [
            ...PROPERTIES_WITHOUT_CHANGES,
            ...PROPERTIES_SHOULD_BE_CONVERTED_TO_ARRAY_OF_NUMBERS,
            ...PROPERTIES_SHOULD_BE_CONVERTED_TO_ARRAY_OF_STRINGS,
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-result-service.js